import { enUS, es, fr, srLatn } from "date-fns/locale";

export type ProLogsLocale = "en" | "fr" | "es" | "sr";

export const dateFnsLocaleMap = {
  en: enUS,
  es: es,
  fr: fr,
  sr: srLatn,
};
